import { useEffect } from "react";

const SITE = "https://siblingo.co";
const DEFAULT_DESC = "SIBLINGO helps larger families prepare for coordinated shopping: official size charts and saved searches, partner collections as approved retailer feeds arrive.";
const OG_IMAGE = SITE + "/hero-wardrobe.jpg";

function setMeta(attr, key, content) {
  if (!content) return;
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) { el = document.createElement("meta"); el.setAttribute(attr, key); document.head.appendChild(el); }
  el.setAttribute("content", content);
}
function setLink(rel, href) {
  let el = document.head.querySelector(`link[rel="${rel}"]`);
  if (!el) { el = document.createElement("link"); el.setAttribute("rel", rel); document.head.appendChild(el); }
  el.setAttribute("href", href);
}

// Per-page SEO: unique title/description, self-referencing canonical, Open Graph + Twitter, robots.
export function Seo({ title, description, path = "", image, noindex = false, robots = null, canonical = true, jsonLd = null }) {
  useEffect(() => {
    const full = title ? `${title} · SIBLINGO` : "SIBLINGO — Dressed. Matched. Done.";
    const desc = description || DEFAULT_DESC;
    const url = SITE + (path || (window.location.pathname === "/" ? "" : window.location.pathname));
    const img = image || OG_IMAGE;
    document.title = full;
    setMeta("name", "description", desc);
    setMeta("name", "robots", robots || (noindex ? "noindex,nofollow" : "index,follow"));
    if (canonical) setLink("canonical", url);
    else { const c = document.head.querySelector('link[rel="canonical"]'); if (c) c.remove(); }
    setMeta("property", "og:title", full);
    setMeta("property", "og:description", desc);
    setMeta("property", "og:type", "website");
    setMeta("property", "og:url", url);
    setMeta("property", "og:image", img && !String(img).startsWith("http") ? `${window.location.origin}${img}` : img);
    setMeta("property", "og:site_name", "SIBLINGO");
    setMeta("name", "twitter:card", "summary_large_image");
    setMeta("name", "twitter:title", full);
    setMeta("name", "twitter:description", desc);
    setMeta("name", "twitter:image", img);
    // Structured data (Product/ItemList/BreadcrumbList) for rich results & affiliate crawlers.
    const existing = document.getElementById("siblingo-jsonld");
    if (existing) existing.remove();
    if (jsonLd) {
      const s = document.createElement("script");
      s.id = "siblingo-jsonld";
      s.type = "application/ld+json";
      s.text = JSON.stringify(jsonLd);
      document.head.appendChild(s);
    }
  }, [title, description, path, image, noindex, robots, canonical, jsonLd]);
  return null;
}
